export default __webpack_public_path__ + "static/media/view-london-city-sunset.16dad6a3.jpg";